import { Fragment } from "react"
import { Header } from "../../shared/components/Header"

export const NotFound: React.FC = () => {
    return (  
    <Fragment>
        <Header title='Página no encontrada' />
    </Fragment>
    )
}